import { render, staticRenderFns } from "./EscolaMinisterial.vue?vue&type=template&id=22b079c9&scoped=true"
import script from "./EscolaMinisterial.vue?vue&type=script&lang=js"
export * from "./EscolaMinisterial.vue?vue&type=script&lang=js"
import style0 from "./EscolaMinisterial.vue?vue&type=style&index=0&id=22b079c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b079c9",
  null
  
)

export default component.exports